import { calculateYearlyPayment } from './calculateYearlyPayment';

type calculateMonthlyPaymentArgs = {
  loanAmount: number;
  loanDuration: number;
  establishRate?: number;
  minRate: number;
};
/**
 * Copy of https://git.lendme.dk/lendme/customer-interface/-/blob/development/src/app/views/bits/monthlyPayment/monthly-payment.component.ts
 */
export function calculateMonthlyPayment(
  args: calculateMonthlyPaymentArgs
): number {
  const { establishRate = 0, loanAmount, loanDuration, minRate } = args;

  const interestRate = minRate / 100;

  const establishCost = (establishRate / 100) * loanAmount;

  const yearlyPayment = calculateYearlyPayment({
    establishCost,
    interestRate,
    loanAmount,
    loanDuration,
  });

  return Math.round(yearlyPayment / 12);
}
